import * as R from 'ramda'

import { setNormalizedScore } from 'utils/score'
import { SKILL_RANGE } from './model'

export const mapInternalStateToPayload = state => {
  const { evaluators, questionComments = {} } = state

  return R.reduce(
    (acc, { comment, key, score }) => {
      const rawComments = R.propOr({}, key, questionComments)
      const comments = R.pipe(
        R.pickBy((_, k) => /^\d+$/.test(String(k))),
        R.reject(R.isEmpty),
        R.when(R.isEmpty, R.always(undefined)),
      )(rawComments)
      return {
        ...acc,
        [key]: R.reject(R.isNil, {
          comment,
          comments,
          score: setNormalizedScore(SKILL_RANGE)(score),
        }),
      }
    },
    {},
    evaluators,
  )
}
